import {
  ButtonPrimary,
  ButtonSecondary,
} from "../../../../components/Button/Button";
import classes from "./Hero.module.css";
import { Link } from "react-router-dom";

const Hero = ({ className }) => {
  return (
    <section className={`${className} ${classes.hero}`}>
      <hgroup>
        <h1 className={classes.hero__title}>
          你想要的細節
          <br /> 我們都做得到
        </h1>
        <h3 className={classes.hero__text}>完全客製化的禮贈品服務</h3>
      </hgroup>
      <div className={classes.button}>
        <Link to="product">
          <ButtonPrimary text="開始挑選" className={classes.hero__button1} />
        </Link>
        <Link to="service">
          <button className={classes.hero__button2}>了解更多</button>
        </Link>
      </div>
    </section>
  );
};

export default Hero;
